import React, { useEffect, useState, useRef } from "react";
import ChecklistModal from "../../components/standalonefs/ChecklistModal";
import ReferenceModal from "../../components/standalonefs/ReferenceModal";
import commoncss from "../../css/common.module.css";
import libcss from "../../css/library.module.css";
import swal from "sweetalert";
import "./ConsolFSTable.css"

import { ReactComponent as DelIcon } from "../../assets/icons/delete_red.svg";


export default function ConsolFSTable({
  columns = [],
  rows = [],
  onRowsChange = () => {},
  onCellChangeImmediate = () => {},
  brandingClass = "ft-branding",
  emptyMessage = "No data for this category",
  containerWidth = "100%",
  redirectTo = () => {},
  checklistRef = () => {},
  tableTitle = null,
  tableId = null,
  tableLayout = "auto",
  tableType = "table",
  deletePopulateFS = () => {},
  isNotesTable = false,
}) {
  const [localRows, setLocalRows] = useState(
    Array.isArray(rows) ? [...rows] : []
  );
  const [editing, setEditing] = useState(null); 
  const inputRef = useRef(null);
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [viewReferenceModal, setViewReferenceModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [refrenceModalData, setReferenceModalData] = useState(null);

  useEffect(() => {
    setLocalRows(Array.isArray(rows) ? [...rows] : []);
    setEditing(null);
  }, [rows]);

  useEffect(() => {
    if (editing && inputRef.current) {
      try {
        inputRef.current.focus();
        inputRef.current.select?.();
      } catch (e) {}
    }
  }, [editing]);

  const startEdit = (rowIdx, col) => {
    if (!col.editable) return;
    if (col.type === "checkbox") return; 
    if ((localRows[rowIdx]?.lineType || "").toLowerCase() === "header") return;
    setEditing({ rowIdx, field: col.field, col });
  };

  const commitValue = (valueStr) => {
    if (!editing) return;
    const { rowIdx, field, col } = editing;
    const updated = [...localRows];
    let newVal = valueStr;

    if (col.type === "number") {
      newVal = valueStr === "" ? null : Number(valueStr);
      if (isNaN(newVal)) newVal = null;
    } else if (col.type === "array") {
      newVal = String(valueStr)
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    }

    updated[rowIdx] = { ...updated[rowIdx], [field]: newVal };
    setLocalRows(updated);
    setEditing(null);

    try {
      onRowsChange(updated);
    } catch (e) {
      console.error("onRowsChange error", e);
    }
  };

  // Emit single-object immediate change: { _id, key, value }
  const emitImmediateChange = (rowIdx, key, value) => {
    const row = localRows[rowIdx] ?? {};
    const id = row._id ?? rowIdx;
    try {
      onCellChangeImmediate({ _id: id, key, value, tableId });
    } catch (e) {
      console.error("onCellChangeImmediate error", e);
    }
  };

  // Handles single-value checkbox option columns (field: "value", optionValue: "Y"/"N"/"NA")
  const toggleSingleValueCheckbox = (rowIdx, col, checked) => {
    if (!col.optionValue) {
      console.warn("[ConsolFSTable] checkbox column missing optionValue", col);
      return;
    }
    const updated = [...localRows];
    const row = { ...updated[rowIdx] };

    if (checked) {
      row[col.field] = col.optionValue;
    } else {
      row[col.field] = null;
    }

    updated[rowIdx] = row;
    setLocalRows(updated);

    // immediate emit single-object diff
    emitImmediateChange(rowIdx, col.field, row[col.field]);

    try {
      onRowsChange(updated);
    } catch (e) {
      console.error("onRowsChange error", e);
    }
  };

  const cancel = () => setEditing(null);

  const displayValue = (row, field, type) => {
  const v = row[field];

  if (v == null || v === "") return "";

  if (Array.isArray(v)) return v.join(", ");

  if (type === "number") {
    const num = Number(v);
    if (isNaN(num)) return v;

    if (num < 0) {
      return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
    }
    return num.toLocaleString("en-IN");
  }

  if (type === "checkbox") return "";

  return String(v);
};

  const totalMinWidthPx = columns.reduce(
    (sum, c) => sum + (c.minWidth ?? c.width ?? 0),
    0
  );


  const normalizedContainerWidth =
    typeof containerWidth === "number"
      ? `${containerWidth}px`
      : containerWidth || "100%";

  const handleChecklistModal = (data) => {
    setModalData([]);
    const modalDataObj = {
      header: data.reference,
      libRef: data.libraryReference,
    };
    setModalData(modalDataObj);
    setShowChecklistModal(true);
  };

  const handleReferenceModal = (data) => {
    setReferenceModalData(data);
    console.log("handleReferenceModal data", data);

    setViewReferenceModal(true);
  };

  const handleDeleteFSTable = () => {
    swal({
      title: "Confirm deletion of linked register data?",
      text: "Once deleted, you will not be able to recover this!",
      //icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "swal-delete-btn",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deletePopulateFS(tableId);
      }
    });
  };
  return (
    <div
      style={{
        width: normalizedContainerWidth,
        //overflowX: "auto",
        marginTop: "20px",
      }}
      id={tableId}
    > 
      <div class="ft-table-scroll"  
       style={{
        borderRadius: isNotesTable ? "10px" : "12px",
        border: "1px solid #eaeeed",
        //overflow: "hidden",
        borderCollapse: "collapse",
        overflowX: "auto",    
        overflowY: "visible",
        postition: "relative",
       }}>
        <table
          className={`ft-table ${brandingClass} ft-scrTable`}
          style={{ minWidth: `${totalMinWidthPx}px`,
          borderCollapse: "collapse",
          tableLayout: tableLayout
        }}
        >
          <thead>
            {tableTitle && (
            <tr className="ft-table-title-row">
              <th colSpan={columns.length}>
                <div className="ft-table-title">
                  <span>{tableTitle}</span>
                  {tableType === "link register" && (
                    <DelIcon onClick={handleDeleteFSTable} />
                  )}
                </div>
              </th>
            </tr>
          )}
            <tr>
              {columns.map((c, i) => (
                <th
                  key={i}
                   style={{
                    minWidth: c.minWidth ? `${c.minWidth}px` : undefined,
                    maxWidth: c.maxWidth ? `${c.maxWidth}px` : undefined,
                    width: c.width ? `${c.width}px` : undefined,
                    textAlign:
                      c.align === "right"
                        ? "right"
                        : c.align === "center"
                        ? "center"
                        : "left",
                  }}
                  className={
                    c.align === "right"
                      ? "ft-align-right"
                      : c.align === "center"
                      ? "ft-align-center"
                      : "ft-align-left"
                  }
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {!localRows || localRows.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{ textAlign: "center", padding: 20 }}
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              localRows.map((row, rIdx) => {
                const rowKey = row._id ?? rIdx;

                if ((row.lineType || "").toLowerCase() === "header") {
                  return (
                    <tr key={rowKey}>
                      <td
                        colSpan={columns.length}
                        style={{
                          //background: "rgb(239,247,240)",
                          background: "#eaeeed",
                          borderCollapse: "collapse",
                          color: "#33584e",
                          fontWeight: 600,
                          textAlign: "left",
                          borderTopLeftRadius: tableTitle ? 0 : undefined,
                          borderTopRightRadius: tableTitle ? 0 : undefined,
                        }}
                      >
                        {row.particular}
                      </td>
                    </tr>
                  );
                }
                const getRowClass = (row) => {
                const text = row.particular?.toLowerCase() || "";

                // if (text.startsWith("restated")) {
                //   return "fs-restated-row";
                // }

                // if (text.startsWith("total") || text.startsWith("balance")) {
                //   return "fs-total-balance-row";
                // }

                return "";
              };

                return (
                 <tr key={rowKey} className={getRowClass(row)}>
                    {columns.map((col, cIdx) => {
                      const isEditing =
                        editing &&
                        editing.rowIdx === rIdx &&
                        editing.field === col.field;
                      const inputAlignClass =
                        col.field === "notes"
                          ? "ft-input-center"
                          : col.align === "right"
                          ? "ft-input-right"
                          : col.align === "center"
                          ? "ft-input-center"
                          : "ft-input-left";

                      const cellText = displayValue(row, col.field, col.type);

                      const handleCellClick = () => {
                        if (col.type === "checkbox") return;
                        startEdit(rIdx, col);
                      };

                      return (
                      <td
                      key={cIdx}
                       style={{
                        minWidth: col.minWidth ? `${col.minWidth}px` : undefined,
                        maxWidth: col.maxWidth ? `${col.maxWidth}px` : undefined,
                        width: col.width ? `${col.width}px` : undefined,
                      }}


                           className={`${
                             col.align === "right"
                              ? "ft-align-right"
                              : col.align === "center"
                              ? "ft-align-center"
                              : "ft-align-left"
                          } ${isEditing ? "ft-editing" : ""}`}
                          onClick={handleCellClick}
                          onDoubleClick={handleCellClick}
                        >
                          {col.type === "popup" && (
                            <div
                              // style={{
                              //   display: "flex",
                              //   alignItems: "center",
                              //   justifyContent:
                              //     col.align === "right"
                              //       ? "flex-end"
                              //       : col.align === "center"
                              //       ? "center"
                              //       : "flex-start",
                              // }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                  col.align === "right"
                                    ? "flex-end"
                                    : col.align === "center"
                                    ? "center"
                                    : "flex-start",
                                textAlign:
                                  col.align === "right"
                                    ? "right"
                                    : col.align === "center"
                                    ? "center"
                                    : "left",
                                width: "100%",
                              }}
                            >
                              <span
                                className={commoncss.clickable}
                                onClick={() => {
                                  handleChecklistModal(row);
                                  console.log(row);
                                }}
                              >
                                {row[col.field]}
                              </span>
                            </div>
                          )}
                          {col.type === "checklistref" && (
                            <div
                              // style={{
                              //   display: "flex",
                              //   alignItems: "center", 
                              //   justifyContent:
                              //     col.align === "right"
                              //       ? "flex-end"
                              //       : col.align === "center"
                              //       ? "center"
                              //       : "flex-start",
                              // }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                  col.align === "right"
                                    ? "flex-end"
                                    : col.align === "center"
                                    ? "center"
                                    : "flex-start",
                                textAlign:
                                  col.align === "right"
                                    ? "right"
                                    : col.align === "center"
                                    ? "center"
                                    : "left",
                                width: "100%",
                              }}
                            >
                              {Array.isArray(row[col.field])
                                ? row[col.field].map((item, index) => (
                                    <span key={index}>
                                      <span
                                        onClick={() => {
                                          handleReferenceModal(item);
                                          console.log("ref item", item);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "8px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item}
                                      </span>
                                      {index < row[col.field].length - 1 &&
                                        ", "}
                                    </span>
                                  ))
                                : row[col.field] ?? ""}
                            </div>
                          )}
                          {col.type === "redirect" && (
                            <div
                              // style={{
                              //   display: "flex",
                              //   alignItems: "center",
                              //   justifyContent:
                              //     col.align === "right"
                              //       ? "flex-end"
                              //       : col.align === "center"
                              //       ? "center"
                              //       : "flex-start",
                              // }}
                              style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent:
                                col.align === "right"
                                  ? "flex-end"
                                  : col.align === "center"
                                  ? "center"
                                  : "flex-start",
                              textAlign:
                                col.align === "right"
                                  ? "right"
                                  : col.align === "center"
                                  ? "center"
                                  : "left",
                              width: "100%",
                            }}
                            >
                              <span
                                className={commoncss.clickable}
                                onClick={() => {
                                  redirectTo(row[col.field]);
                                }}
                              >
                                {row[col.field]}
                              </span>
                            </div>
                          )}
                          {col.type === "checkbox" ? (
                            <div
                              // style={{
                              //   display: "flex",
                              //   alignItems: "center",
                              //   justifyContent:
                              //     col.align === "right"
                              //       ? "flex-end"
                              //       : col.align === "center"
                              //       ? "center"
                              //       : "flex-start",
                              // }}
                              style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent:
                                col.align === "right"
                                  ? "flex-end"
                                  : col.align === "center"
                                  ? "center"
                                  : "flex-start",
                              textAlign:
                                col.align === "right"
                                  ? "right"
                                  : col.align === "center"
                                  ? "center"
                                  : "left",
                              width: "100%",
                            }}
                            >
                              <input
                                name={`chk_${rowKey}_${col.field}_${col.optionValue}`}
                                className="ft-checkbox"
                                type="checkbox"
                                checked={row[col.field] === col.optionValue}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  toggleSingleValueCheckbox(rIdx, col, checked);
                                }}
                                onClick={(e) => e.stopPropagation()}
                                aria-label={`${col.label} checkbox row ${rIdx}`}
                              />
                            </div>
                          ) : (
                            <>
                              {col.type !== "redirect" &&
                                col.type !== "popup" &&
                                col.type !== "checklistref" && (
                                  <div
                                    style={{
                                      visibility: isEditing
                                        ? "hidden"
                                        : "visible",
                                        textAlign:
                                        col.align === "right"
                                          ? "right"
                                          : col.align === "center"
                                          ? "center"
                                          : "left",
                                      width: "100%",
                                    }}
                                  >
                                    {cellText}
                                  </div>
                                )}

                              {isEditing &&
                                col.type !== "redirect" &&
                                col.type !== "popup" &&
                                col.type !== "checklistref" && (
                                  <input
                                    ref={inputRef}
                                    className={`ft-edit-input ${inputAlignClass}`}
                                    type={
                                      col.type === "number" ? "number" : "text"
                                    }
                                    defaultValue={
                                      col.type === "array" &&
                                      Array.isArray(row[col.field])
                                        ? row[col.field].join(", ")
                                        : row[col.field] ?? ""
                                    }
                                    onBlur={(e) => commitValue(e.target.value)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter")
                                        commitValue(e.target.value);
                                      if (e.key === "Escape") cancel();
                                    }}
                                    onKeyUp={(e) => {
                                      const raw = e.target.value;
                                      // compute outgoing according to type
                                      let outgoing = raw;
                                      if (col.type === "number") {
                                        const n =
                                          raw === "" ? null : Number(raw);
                                        outgoing = isNaN(n) ? null : n;
                                      } else if (col.type === "array") {
                                        outgoing = String(raw)
                                          .split(",")
                                          .map((v) => v.trim())
                                          .filter(Boolean);
                                      }
                                      // update localRows so UI is responsive while typing
                                      const updated = [...localRows];
                                      updated[rIdx] = {
                                        ...updated[rIdx],
                                        [col.field]: outgoing,
                                      };
                                      setLocalRows(updated);
                                      // emit single-object immediate diff
                                      emitImmediateChange(
                                        rIdx,
                                        col.field,
                                        outgoing
                                      );
                                    }}
                                  />
                                )}
                            </>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {showChecklistModal && modalData && (
        <ChecklistModal
          setShowChecklistModal={setShowChecklistModal}
          modalData={modalData}
        />
      )}
      {viewReferenceModal && refrenceModalData && (
        <ReferenceModal
          setViewReferenceModal={setViewReferenceModal}
          modalData={refrenceModalData}
        />
      )}
    </div>
  );
}